export const DEVICE_AND_LOCATION_DETAILS_ENABLED = true;
export const FORMS_PAGE_ENABLED = false;
export const REDACTIONS_ENABLED = true;
export const PROACTIVE_CHAT_ENABLED = true;
export const MANAGE_USER_STATES_ENABLED = true;
export const TEXT_LOCALISATIONS_ENABLED = true;
export const LIVE_AGENTS_REPORTING_ENABLED = true;
export const LIVE_AGENTS_FORCE_SIGN_OUT_ENABLED = true;
